import { useEffect, useState } from "react";
import { storage } from "../../../../utils/storage";
import { AnnouncementStates, Props, Status } from "./types";

const getStorageName = (name: string) => `announcement-${btoa(name)}`;

const isExpired = ({ expiresAt }: Status) => {
  const expiryDate = new Date(expiresAt);
  const currentDate = new Date();

  return currentDate.getTime() > expiryDate.getTime();
}

const useDisplayStatus = ({ name }: Props): Status | null => {
  const [status, setStatus] = useState<Status | null>({ state: AnnouncementStates.Dismissed } as Status)

  useEffect(() => {
    setStatus(storage.get(getStorageName(name)))
  }, [name])

  return status
}

const setStorage = ({ name, expiresAt }: Props, state: AnnouncementStates) => storage
  .set(getStorageName(name), { state, expiresAt })

export const useSetInitialVisibility = (props: Props, setVisible: (visible: boolean) => void) => {
  const status = useDisplayStatus(props)

  useEffect(() => {
    if (!status) {
      setStorage(props, AnnouncementStates.NotDismissed)
      setVisible(true)
    } else {
      const shouldBeVisible = !isExpired(status) && status.state !== AnnouncementStates.Dismissed

      setVisible(shouldBeVisible)
    }
  }, [status, props])

}

export const closeAnnouncement = (props: Props, setVisible: (visible: boolean) => void) => {
  setStorage(props, AnnouncementStates.Dismissed);
  setVisible(false)
};

